/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";

function DeleteIcon({ width = 14, height = 14, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      {...props}
    >
      <path
        d="M2.88524 14C2.40998 14 2.005 13.8326 1.6703 13.4979C1.33559 13.1632 1.16824 12.7583 1.16824 12.283V2.57547H0.309753V0.858489H4.34052V0H9.06734V0.858489H13.1071V2.57547H12.2486V12.283C12.2486 12.7583 12.0813 13.1632 11.7466 13.4979C11.4119 13.8326 11.0069 14 10.5316 14H2.88524ZM10.5316 2.57547H2.88524V12.283H10.5316V2.57547ZM4.36309 10.8232H5.97629V4.03077H4.36309V10.8232ZM7.44059 10.8232H9.0538V4.03077H7.44059V10.8232Z"
        fill="black"
      />
    </svg>
  );
}

export default DeleteIcon;
